//UI Components
const UIHeader = () => import("./components/UI/Header.vue");
const UIContent = () => import("./components/UI/Content.vue");
const UIButton = () => import("./components/UI/Button.vue");
const UIButtonLight = () => import("./components/UI/ButtonLight.vue");
const UIGoogleButton = () => import("./components/UI/GoogleButton.vue");
const UIButtonLoader = () => import("./components/UI/ButtonLoader.vue");
const UISearch = () => import("./components/UI/Search.vue");
const UIModal = () => import("./components/UI/Modal.vue");
const UITransparentModal = () => import("./components/UI/TransparentModal.vue");
const UIInput = () => import("./components/UI/Input.vue");
const UIInputDefault = () => import("./components/UI/InputDefault.vue");
const UIInputLight = () => import("./components/UI/InputLight.vue");
const UIInputNavbar = () => import("./components/UI/InputNavbar.vue");
const UIAutoResizeInput = () => import("./components/UI/AutoResizeInput.vue");
const UIMentionableInput = () => import("./components/UI/MentionableInput.vue");
const UITextarea = () => import("./components/UI/Textarea.vue");
const UILabel = () => import("./components/UI/Label.vue");
const UIFormLabel = () => import("./components/UI/FormLabel.vue");
const UILoader = () => import("./components/UI/Loader.vue");
const UIGoogleLoader = () => import("./components/UI/GoogleLoader.vue");
const UIOverview = () => import("./components/UI/Overview.vue");
const UIDropdown = () => import("./components/UI/Dropdown.vue");
const UIDropdownDefault = () => import("./components/UI/DropdownDefault.vue");
const UIDropdownButton = () => import("./components/UI/DropdownButton.vue");
const UIDropdownMini = () => import("./components/UI/DropdownMini.vue");
const UISearchDropdown = () => import("./components/UI/SearchDropdown.vue");
const UITabs = () => import("./components/UI/Tabs.vue");
const UIDefaultField = () => import("./components/UI/DefaultField.vue");
const UIToggle = () => import("./components/UI/Toggle.vue");
const UIToggleButton = () => import("./components/UI/ToggleButton.vue");
const UICheckbox = () => import("./components/UI/Checkbox.vue");
const UIRadioGroup = () => import("./components/UI/RadioGroup.vue");
const UIImageUpload = () => import("./components/UI/ImageUpload.vue");
const UIFileUpload = () => import("./components/UI/FileUpload.vue");
const UIBottomSheet = () => import("./components/UI/BottomSheet.vue");
const UIFloatingActionButton = () =>
    import("./components/UI/FloatingActionButton.vue");
const UILongFloatingActionButton = () =>
    import("./components/UI/LongFloatingActionButton.vue");
const UIDrawerLeft = () => import("./components/UI/DrawerLeft.vue");
const UIMultiselect = () => import("./components/UI/Multiselect.vue");
const UIMultiselectLight = () => import("./components/UI/MultiselectLight.vue");
const UITag = () => import("./components/UI/Tag.vue");
const UICheckboxTag = () => import("./components/UI/CheckboxTag.vue");
const UITooltip = () => import("./components/UI/Tooltip.vue");
const UICollapsibleContainer = () =>
    import("./components/UI/CollapsibleContainer.vue");
const UIStepIndicator = () => import("./components/UI/StepIndicator.vue");
const UICircularAvatars = () => import("./components/UI/CircularAvatars.vue");
const UIPaginator = () => import("./components/Paginator.vue");
const UIBitmovinPlayer = () => import("./components/BitmovinPlayer.vue");
const UIVueMultiselect = () => import("vue-multiselect");

Vue.component("page-header", UIHeader);
Vue.component("page-content", UIContent);
Vue.component("v-button", UIButton);
Vue.component("v-button-light", UIButtonLight);
Vue.component("v-google-button", UIGoogleButton);
Vue.component("v-button-loader", UIButtonLoader);
Vue.component("v-search", UISearch);
Vue.component("v-modal", UIModal);
Vue.component("v-transparent-modal", UITransparentModal);
Vue.component("v-input", UIInput);
Vue.component("v-input-default", UIInputDefault);
Vue.component("v-input-light", UIInputLight);
Vue.component("v-input-navbar", UIInputNavbar);
Vue.component("v-auto-resize-input", UIAutoResizeInput);
Vue.component("v-mentionable-input", UIMentionableInput);
Vue.component("v-textarea", UITextarea);
Vue.component("v-label", UILabel);
Vue.component("v-form-label", UIFormLabel);
Vue.component("v-loader", UILoader);
Vue.component("v-google-loader", UIGoogleLoader);
Vue.component("v-overview", UIOverview);
Vue.component("v-dropdown", UIDropdown);
Vue.component("v-dropdown-default", UIDropdownDefault);
Vue.component("v-dropdown-button", UIDropdownButton);
Vue.component("v-dropdown-mini", UIDropdownMini);
Vue.component("v-search-dropdown", UISearchDropdown);
Vue.component("v-tabs", UITabs);
Vue.component("v-default-field", UIDefaultField);
Vue.component("v-toggle", UIToggle);
Vue.component("v-toggle-button", UIToggleButton);
Vue.component("v-checkbox", UICheckbox);
Vue.component("v-radio-group", UIRadioGroup);
Vue.component("v-image-upload", UIImageUpload);
Vue.component("v-file-upload", UIFileUpload);
Vue.component("v-bottom-sheet", UIBottomSheet);
Vue.component("v-fab", UIFloatingActionButton);
Vue.component("v-long-fab", UILongFloatingActionButton);
Vue.component("v-drawer-left", UIDrawerLeft);
Vue.component("v-multiselect", UIMultiselect);
Vue.component("v-multiselect-light", UIMultiselectLight);
Vue.component("v-tag", UITag);
Vue.component("v-checkbox-tag", UICheckboxTag);
Vue.component("v-tooltip", UITooltip);
Vue.component("v-collapsible-container", UICollapsibleContainer);
Vue.component("v-step-indicator", UIStepIndicator);
Vue.component("v-circular-avatars", UICircularAvatars);
Vue.component("v-paginator", UIPaginator);
Vue.component("v-bitmovin-player", UIBitmovinPlayer);
Vue.component("multiselect", UIVueMultiselect);

//Partials
const PartialsNavbar = () => import("./partials/navbar/Navbar.vue");
const PartialsCommunities = () =>
    import("./partials/sidebars/partials/Communities.vue");
const PartialsSubNavbar = () => import("./partials/SubNavbar.vue");
const PartialsFooter = () => import("./partials/Footer.vue");
const PartialsCta = () => import("./partials/Cta.vue");
const PartialsGenreTag = () => import("./partials/GenreTag.vue");
const PartialsLeftSide = () => import("./partials/sidebars/LeftSide.vue");
const PartialsRightSide = () => import("./partials/sidebars/RightSide.vue");
const PartialsRightDrawer = () => import("./partials/sidebars/RightDrawer.vue");
const PartialsLibrary = () => import("./partials/library/Library.vue");
const PartialsLibraryCard = () => import("./partials/library/LibraryCard.vue");
const PartialsMoviePicker = () => import("./partials/MoviePicker.vue");
const PartialsCreatorPicker = () => import("./partials/CreatorPicker.vue");
const PartialsMovieOverview = () => import("./partials/MovieOverview.vue");
const PartialsAvatar = () => import("./partials/Avatar.vue");
const PartialsProfilePicture = () => import("./partials/ProfilePicture.vue");
const PartialsComments = () => import("./partials/comments/Comments.vue");
const PartialsReviewCard = () => import("./partials/reviews/ReviewCard.vue");
const PartialsReviewForm = () => import("./partials/reviews/ReviewForm.vue");
const PartialsReviewHeader = () =>
    import("./partials/reviews/ReviewHeader.vue");
const PartialsOptionTabs = () => import("./partials/tabs/OptionTabs.vue");
const PartialsOptionTag = () =>
    import("./partials/tabs/partials/OptionTag.vue");
const PartialsPeople = () => import("./partials/people/People.vue");
const PartialsPeopleCard = () => import("./partials/people/PeopleCard.vue");
const PartialsChart = () => import("./partials/Chart.vue");
const PartialsAdManagerSlot = () => import("./partials/AdManagerSlot.vue");
const PartialsAdSenseSlot = () => import("./partials/AdSenseSlot.vue");
const PartialsSovrnSlot = () => import("./partials/SovrnSlot.vue");
const PartialsChallenges = () => import("./partials/challenges/Challenges.vue");
const PartialsFriendRequestDecision = () =>
    import("./partials/friends/FriendRequestDecision.vue");

Vue.component("v-navbar", PartialsNavbar);
Vue.component("v-communities", PartialsCommunities);
Vue.component("v-sub-navbar", PartialsSubNavbar);
Vue.component("v-footer", PartialsFooter);
Vue.component("v-cta", PartialsCta);
Vue.component("v-genre-tag", PartialsGenreTag);
Vue.component("v-left-side", PartialsLeftSide);
Vue.component("v-right-side", PartialsRightSide);
Vue.component("v-right-drawer", PartialsRightDrawer);
Vue.component("v-library", PartialsLibrary);
Vue.component("v-library-card", PartialsLibraryCard);
Vue.component("v-movie-picker", PartialsMoviePicker);
Vue.component("v-creator-picker", PartialsCreatorPicker);
Vue.component("v-movie-overview", PartialsMovieOverview);
Vue.component("v-avatar", PartialsAvatar);
Vue.component("v-profile-picture", PartialsProfilePicture);
Vue.component("v-comments", PartialsComments);
Vue.component("v-review-card", PartialsReviewCard);
Vue.component("v-review-form", PartialsReviewForm);
Vue.component("v-review-header", PartialsReviewHeader);
Vue.component("v-option-tabs", PartialsOptionTabs);
Vue.component("v-option-tag", PartialsOptionTag);
Vue.component("v-people", PartialsPeople);
Vue.component("v-people-card", PartialsPeopleCard);
Vue.component("v-chart", PartialsChart);
Vue.component("v-ad-manager-slot", PartialsAdManagerSlot);
Vue.component("v-ad-sense-slot", PartialsAdSenseSlot);
Vue.component("v-sovrn-slot", PartialsSovrnSlot);
Vue.component("v-challenges", PartialsChallenges);
Vue.component("v-friend-request-decision", PartialsFriendRequestDecision);

//Pages
const Home = () => import("./pages/home/Home.vue");
const Signup = () => import("./pages/signup/Signup.vue");
const Login = () => import("./pages/login/Login.vue");
const ForgotPassword = () =>
    import("./pages/forgotPassword/ForgotPassword.vue");
const PasswordReset = () => import("./pages/passwordReset/PasswordReset.vue");
const Onboarding = () => import("./pages/onboarding/Onboarding.vue");
const HomeAuth = () => import("./pages/home_auth/HomeAuth.vue");
const Subscriptions = () => import("./pages/subscriptions/Subscriptions.vue");
const AdInfo = () => import("./pages/adInfo/AdInfo.vue");
const ProfileCompleted = () =>
    import("./pages/profileCompleted/ProfileCompleted.vue");
const TermsConditions = () =>
    import("./pages/termsConditions/TermsConditions.vue");
const PrivacyPolicy = () => import("./pages/privacyPolicy/PrivacyPolicy.vue");
const Impressum = () => import("./pages/impressum/Impressum.vue");
const Invite = () => import("./pages/invite/Invite.vue");
const WordFromFounder = () =>
    import("./pages/wordFromFounder/WordFromFounder.vue");
const Mockup = () => import("./pages/mockup/Mockup.vue");
const Dashboard = () => import("./pages/dashboard/Dashboard.vue");
const MovieForm = () =>
    import("./pages/dashboard/pages/movieForm/MovieForm.vue");
const SeriesForm = () =>
    import("./pages/dashboard/pages/seriesForm/SeriesForm.vue");
const PartnerCompanyForm = () =>
    import("./pages/dashboard/pages/partnerCompanyForm/PartnerCompanyForm.vue");
const PlayerTest = () => import("./pages/playerTest/PlayerTest.vue");
const EmailNotVerified = () =>
    import("./pages/email_verification/EmailNotVerified.vue");
const EmailVerified = () => import("./pages/email_verification/EmailVerified.vue");
const Feed = () => import("./pages/feed/Feed.vue");
const Watch = () => import("./pages/watch/Watch.vue");
const Post = () => import("./pages/post/Post.vue");
const WatchSeries = () => import("./pages/watchSeries/WatchSeries.vue");
const Library = () => import("./pages/library/Library.vue");
const Crew = () => import("./pages/crew/Crew.vue");
const Settings = () => import("./pages/settings/Settings.vue");
const Profile = () => import("./pages/profile/Profile.vue");
const Reviews = () => import("./pages/reviews/Reviews.vue");
const Share = () => import("./pages/share/Share.vue");
const Search = () => import("./pages/search/Search.vue");
const Notifications = () => import("./pages/notifications/Notifications.vue");
const GlobalNotifications = () => import('./components/GlobalNotification.vue');

Vue.component("home", Home);
Vue.component("signup", Signup);
Vue.component("login", Login);
Vue.component("forgot-password", ForgotPassword);
Vue.component("password-reset", PasswordReset);
Vue.component("onboarding", Onboarding);
Vue.component("home-auth", HomeAuth);
Vue.component("subscriptions", Subscriptions);
Vue.component("ad-info", AdInfo);
Vue.component("profile-completed", ProfileCompleted);
Vue.component("terms-conditions", TermsConditions);
Vue.component("privacy-policy", PrivacyPolicy);
Vue.component("impressum", Impressum);
Vue.component("invite", Invite);
Vue.component("word-from-founder", WordFromFounder);
Vue.component("mockup", Mockup);
Vue.component("dashboard", Dashboard);
Vue.component("movie-form", MovieForm);
Vue.component("series-form", SeriesForm);
Vue.component("partner-company-form", PartnerCompanyForm);
Vue.component("player-test", PlayerTest);
Vue.component("email-not-verified", EmailNotVerified);
Vue.component("email-verified", EmailVerified);
Vue.component("feed", Feed);
Vue.component("watch", Watch);
Vue.component("post", Post);
Vue.component("watch-series", WatchSeries);
Vue.component("library", Library);
Vue.component("crew", Crew);
Vue.component("settings", Settings);
Vue.component("profile", Profile);
Vue.component("reviews", Reviews);
Vue.component("share", Share);
Vue.component("search", Search);
Vue.component("notifications", Notifications);
Vue.component("global-notifications", GlobalNotifications);


// Translations
const TranslationProvider = () => import("./components/UI/TranslationProvider.vue");


Vue.component("translation-provider", TranslationProvider);

//Components
const LanguageSelectionModal = () => import("./components/LanguageSelectionModal.vue");

// Register components
Vue.component('language-selection-modal', LanguageSelectionModal);
